import { atom } from "recoil";

export const addBarcodeResultState = atom({
  key: "addBarcodeResultState",
  default: {},
});
